import React, { useEffect, useState } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import GlobalLoader from "../../common/GlobalLoader";
import { getBlog } from "../../../helper/apicalls/blog";
import "../../../styles/admin/blog.scss";

const BlogViewer = () => {
  const { setHeaderName, setIsShowSearch } = useOutletContext();
  const [searchParams] = useSearchParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const isBlogPublished = (item) => {
    if (!item) return false;
    if (typeof item.publish === "boolean") return item.publish;
    if (typeof item.published === "boolean") return item.published;
    if (typeof item.is_published === "boolean") return item.is_published;
    if (typeof item.status === "string") {
      return item.status.toLowerCase() === "published";
    }
    return false;
  };

  useEffect(() => {
    setHeaderName("Current Affair Details");
    setIsShowSearch && setIsShowSearch(false);
  }, []);

  useEffect(() => {
    const fetchBlog = async () => {
      const id = (searchParams.get("id") || "").trim();
      if (!id) return;
      try {
        setLoading(true);
        setError(null);
        const data = await getBlog(id);
        setBlog(data || null);
      } catch (err) {
        setError("Failed to load blog. Please try again.");
        setBlog(null);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [searchParams]);

  return (
    <div className="blog-container blog-viewer-container">
      {loading && <GlobalLoader visible={loading} />}
      {error && <div className="overall-tests-error">{error}</div>}

      {!loading && !error && blog && (
        <div className="blog-viewer">
          <div className="blog-viewer-header">
            <div
              className={`blog-viewer-status ${
                isBlogPublished(blog)
                  ? "blog-viewer-status--published"
                  : "blog-viewer-status--draft"
              }`}
            >
              {isBlogPublished(blog) ? "Published" : "Draft"}
            </div>
          </div>
          {blog.image_url && (
            <div className="blog-viewer-image-wrapper">
              <img
                src={blog.image_url}
                alt={blog.title || "Blog image"}
                className="blog-viewer-image"
              />
            </div>
          )}
          <h1 className="blog-viewer-title">
            {blog.title || blog.name || "Untitled Blog"}
          </h1>
          {blog.blog_description && (
            <p className="blog-viewer-subtitle">{blog.blog_description}</p>
          )}
          {blog.description && (
            <div
              className="blog-viewer-body"
              dangerouslySetInnerHTML={{ __html: blog.description }}
            />
          )}
        </div>
      )}

      {!loading && !error && !blog && (
        <div className="overall-tests-error">Blog not found.</div>
      )}
    </div>
  );
};

export default BlogViewer;
